import React, { createContext, useContext, useState , useEffect} from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [roles, setRoles] = useState([]);
  const [jwtToken, setJwtToken] = useState(localStorage.getItem("jwt") || "");
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("jwt"));
  const [userRole, setUserRole] = useState(localStorage.getItem("role") || "");

  useEffect(() => {
    // Load authentication state on mount
    const storedToken = localStorage.getItem("jwt");
    const storedRole = localStorage.getItem("role");

    if (storedToken) {
      setJwtToken(storedToken);
      setIsLoggedIn(true);
      setUserRole(storedRole);
    }
  }, []);

  console.log("AuthContext#jwtToken: " + jwtToken);
  console.log("AuthContext#userRole: " + userRole);
  console.log("------------------------------------AuthContext#Block#Finish:------------------------------------");


  const login = (response) => {
    localStorage.setItem("jwt", response.jwt);
    localStorage.setItem("role", response.role);
    setJwtToken(response.jwt);
    setIsLoggedIn(true);
    setUserRole(response.role);
  };

  const logout = () => {
    localStorage.removeItem("jwt");
    localStorage.removeItem("role");
    setJwtToken("");
    setIsLoggedIn(false);
    setUserRole("");
  };

  return (
    <AuthContext.Provider
      value={{ roles, userRole, jwtToken, isLoggedIn, login, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
